export enum PageIdentifier {
  Home = 'home',
  Menu = 'menu',
}

export enum ColorVariables {
  PrimaryColor = 'primary_color',
  SecondaryColor = 'secondary_color',
  HeaderColor = 'header_color',
  DescriptionColor = 'description_color',
  DarkTextColor = 'dark_text_color',
  LightTextColor = 'light_text_color',
  BackgroundColor = 'background_color',
  SecondaryBackgroundColor = 'secondary_background_color',
  BorderColor = 'border_color',
  CardColor = 'card_color',
  IconColor = 'icon_color',
}

export enum BorderRadius {
  None = 'none',
  Small = 'small',
  Medium = 'medium',
}

export enum BorderWidth {
  None = 'none',
  Light = 'light',
  Small = 'small',
  Medium = 'medium',
}

export enum ButtonVariant {
  PrimaryFill = 'primary_fill',
  SecondaryFill = 'secondary_fill',
  LightOutline = 'light_outline',
  DarkOutline = 'dark_outline',
}

export enum StorefrontPages {
  Home = '/',
  GiftCards = '/gutscheine',
}
